/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { fieldSettingsRelayResource } from '@jira/router-resources__project-settings-fields/src/fieldSettingsRelayResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskFieldsRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskFieldsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import FieldSettingsPage, { LazyFieldsSettings } from './ui/fields/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskFieldsRouteEntry: Route = createEntry(
	projectSettingsServicedeskFieldsRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'project-settings.fields.jsm-tmp',
		// eslint-disable-next-line no-restricted-syntax
		component: FieldSettingsPage,
		layout: serviceProjectLayout,

		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			fieldSettingsRelayResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyFieldsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
